import { ref } from 'vue'
import type { Toast, ToastOptions } from './types'
import type { Severity as MessageSeverity } from '../message/types'

const toasts = ref<Toast[]>([])
let nextId = 0

export function useToast(defaultOptions?: Partial<ToastOptions>) {
  const defaults: ToastOptions = {
    message: '',
    severity: 'info',
    lifetime: 3000,
    ...defaultOptions,
  }

  const show = (options: string | ToastOptions) => {
    const defaultLifetime = 3000
    const config =
      typeof options === 'string'
        ? { ...defaults, message: options }
        : { ...defaults, ...options }

    const toast: Toast = {
      id: nextId++,
      message: config.message,
      severity: config.severity as MessageSeverity,
      lifetime: config.lifetime || defaultLifetime,
      type: config.type || 'text',
      icon: config.icon,
      title: config.title,
    }

    toasts.value.push(toast)

    if (toast.lifetime > 0) {
      setTimeout(() => {
        remove(toast.id)
      }, toast.lifetime)
    }
  }

  const remove = (id: number) => {
    toasts.value = toasts.value.filter(t => t.id !== id)
  }

  return {
    toasts,
    show,
    remove,
  }
}
